module.exports = "<div class=\"banner notice\" ng-show=\"$ctrl.isVisible()\">\n  <div class=\"wrapper\">\n    <p class=\"title\">\n      <span class=\"icon\"></span>\n      <span>{{ (flashState$ | async).additionalInfos.title | translate }}</span>\n    </p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/flash/flash-update/flash-update.component.html
// module id = 1200
// module chunks = 0